import React from 'react';

import notFoundImg from 'assets/undraw_page_not_found.svg';

import { Container } from './styles';

const NotFound: React.FC = () => {
  return (
    <Container>
      <img src={notFoundImg} alt="Not found" />
      <h2>A página que você esta procurando não foi encontrada :(</h2>
    </Container>
  );
};

export default NotFound;
